import { render } from "./administration.vue?vue&type=template&id=0306a556&scoped=true"
import script from "./administration.js?vue&type=script&lang=js"
export * from "./administration.js?vue&type=script&lang=js"

import "./administration.vue?vue&type=style&index=0&id=0306a556&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0306a556"]])

export default __exports__